import authService from "../../services/authService";
import Vue from 'vue'

const state = {
    isAuth: false,
    loading: false,
    logout_loading: false,
    auth_info: {}
};

const actions = {
    socialAuth({dispatch, state}, data) {
        state.loading = true;
        authService.socialAuth(data)
            .then(response => {
                Vue.$storage.set(`${location.host}-token`, response['token'], {ttl: 1000 * 60 * 60 * 24 * 7});
                const redirect_auth = Vue.$storage.pull('redirect_auth'); // Задается в Auth.vue перед запросом к ВК Api
                window.open(redirect_auth, '_self')
                // router.push(redirect_auth);
                // location.reload();
            })
            .catch(error => {
                dispatch('auth/logout', null, {root: true});
                Vue.toasted.show(`<div>ОШИБКА<br>Не удалось пройти авторизацию.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response.data.detail || "Без описания."}</div>`, {
                    type: 'error',
                    position: 'bottom-center',
                    action: {
                        text: 'Ок',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    },
                });

                state.loading = false;
            })
    },
    logout({commit, state}) {
        state.logout_loading = true;
        return new Promise((resolve, reject) => {
            authService.logout()
                .then(() => {
                    commit('logout');
                    resolve()
                })
                .catch(error => {
                    commit('logout');
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось выйти.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response.data.detail || "Без описания."}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    state.logout_loading = false;
                    reject()
                });
        })
    }
};

const mutations = {
    setIsAuth(state) {
        state.isAuth = true;
    },
    logout(state) {
        Vue.$storage.remove(`${location.host}-token`)
        state.isAuth = false;
    },
    setAuthInfo(state, info) {
        state.auth_info = info;
    }
}

export default {
    namespaced: true,
    actions,
    state,
    mutations,
}